import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* billingAddCredits({ payload: { amount, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.billing.credits.add,
      data: {
        amount_cents: Number.parseFloat(amount) * 100
      }
    });

    onSuccess && onSuccess(data.result);
    yield put(actions.billingAddCreditsDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.billingAddCreditsFailed,
      handledErrors,
      endpoint: api.billing.credits.add.url
    });
  }
}

export const billingAddCreditsSaga = takeEvery(types.BILLING_ADD_CREDITS_REQUEST, billingAddCredits);